import { useUnit } from 'effector-react';
import $$giftTrust from 'models/gift-trusts';
import $$giftTrustPage from 'models/pages/gift-trust';

import './GiftTrustPage.scss';

import LearnCenter from 'components/pages/Dashboard/common/LearnCenter';
import AddGiftItemModal from 'components/pages/GiftTrustPage/AddGiftItemModal';
import GiftTrustDocumentsModal from 'components/pages/GiftTrustPage/GiftTrustDocumentsModal';
import InstanceTab from 'components/pages/GiftTrustPage/InstanceTab';

import useResources from 'hooks/useResources';

import imgGiftTrustImage from 'assets/gift-trust-image.png';

const GiftTrustPage = () => {
    const { t } = useResources();

    const giftTrustQInstances = useUnit($$giftTrustPage.$qInstances);
    const isCreatedAtLeastOne = giftTrustQInstances.length > 0;
    const isCreationInProgress = useUnit($$giftTrust.createNewInstanceFx.pending);

    if (isCreatedAtLeastOne) {
        return (
            <div className="gift-trust-page">
                <AddGiftItemModal />
                <GiftTrustDocumentsModal />
                <div className="w-100 d-flex align-items-center justify-content-between border-bottom pb-3 mb-3">
                    <span className="h4 text-secondary serif">{t('giftTrustPage.selectToExpand')}</span>
                    <button
                        className="btn btn-outline-dark"
                        onClick={() => $$giftTrustPage.createGiftTrustButtonClicked()}
                        disabled={isCreationInProgress}
                    >
                        {t('giftTrustPage.createGiftTrustButton')}
                    </button>
                </div>
                {giftTrustQInstances.map(({ questionnaire_instance_id: qInstanceId }, index) => (
                    <InstanceTab key={qInstanceId} qInstanceId={qInstanceId} isFirst={index === 0} />
                ))}
            </div>
        );
    }

    return (
        <div className="gift-trust-page">
            <p>{t('giftTrustPage.description')}</p>
            <div className="d-flex flex-column align-items-center justify-content-center mobile-full-screen-with">
                <img alt="Gift Trust" className="img-fluid rounded-0 rounded-md-lg" src={imgGiftTrustImage} />
                <div className="card p-4 d-flex flex-column align-items-center justify-content-center w-fit mw-sm">
                    <h3 className="text-center serif text-black">{t('giftTrustPage.getStartedBlock.title')}</h3>
                    <p className="text-center text-secondary">{t('giftTrustPage.getStartedBlock.description')}</p>
                    <button className="btn btn-primary" onClick={() => $$giftTrustPage.createGiftTrustButtonClicked()}>
                        {t('giftTrustPage.getStartedBlock.button')}
                    </button>
                </div>
            </div>
            <LearnCenter articles={t('newDashboardPage.learnCenter.articles', { returnObjects: true })} />
        </div>
    );
};

export default GiftTrustPage;
